'use strict';

module.exports = ['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('ngDroErrorInterceptor');
}];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/configs/HttpInterceptors.js
// module id = 362
// module chunks = 0